export default {
  'Header.logout': 'Log out',
  'Header.analyzedText': 'Reviews analyzed',
}
